var _ellipse, _ellipse2, _ellipse3, _ellipse4, _mask, _g, _ellipse5, _path, _path2, _g2, _g3, _g4, _ellipse6, _path3, _path4, _path5, _g5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _mask2, _g6, _mask3, _g7, _mask4, _g8, _mask5, _g9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgPeopleLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 300,
    viewBox: "0 0 415 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 295.515,
    cy: 274.833,
    rx: 2.98453,
    ry: 2.98638,
    fill: "#47ECFE"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 345.258,
    cy: 48.8638,
    rx: 4.97422,
    ry: 4.9773,
    fill: "#47ECFE",
    fillOpacity: 0.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.9072,
    cy: 68.7728,
    rx: 5.96907,
    ry: 5.97276,
    fill: "#1DE9B6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.485,
    cy: 23.9773,
    rx: 4.97422,
    ry: 4.9773,
    fill: "#B3E5FC"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 85,
    width: 156,
    height: 215
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 85,
    width: 156,
    height: 215,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 107.787,
    width: 126,
    height: 227.786,
    rx: 10,
    fill: "#F8F9FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.745,
    y: 105.596,
    width: 126.538,
    height: 231.96,
    rx: 12,
    fill: "#F8F9FD",
    stroke: "#CBCED2",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.629 107.596H239.392L236.199 114.774C235.717 115.857 234.643 116.555 233.458 116.555H182.563C181.377 116.555 180.303 115.857 179.822 114.774L176.629 107.596Z",
    fill: "#CBCED2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.715,
    y: 138.455,
    width: 106.598,
    height: 100.541,
    rx: 5,
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.516,
    cy: 186.238,
    rx: 14.9436,
    ry: 14.9319,
    fill: "#CBCED2",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.237 185.405C213.831 185.801 213.831 186.674 213.237 187.07L204.086 193.166C203.421 193.608 202.531 193.132 202.531 192.333L202.531 180.141C202.531 179.343 203.421 178.866 204.086 179.309L213.237 185.405Z",
    fill: "#CBCED2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.715,
    y: 249.947,
    width: 106.598,
    height: 24.8865,
    rx: 5,
    fill: "#F1F3F7"
  })))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 354.211,
    cy: 253.929,
    rx: 16.9124,
    ry: 16.9228,
    fill: "#46EDC3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.499 254.642C354.659 256.279 357.102 255.992 358.298 254.642L360.678 252.248C362.023 250.778 362.071 248.879 360.678 247.459C359.319 246.073 357.251 246.073 355.892 247.459L353.499 249.853",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M355.892 253.529C354.731 251.892 352.302 252.096 351.106 253.445L348.713 255.81C347.368 257.28 347.32 259.209 348.713 260.629C350.072 262.014 352.14 262.014 353.499 260.629L355.892 258.234",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 375.987,
    cy: 84.2578,
    rx: 11.9381,
    ry: 11.9455,
    fill: "#46EDC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.484 84.7615C376.304 85.9168 378.028 85.714 378.872 84.7615L380.552 83.0713C381.501 82.0334 381.535 80.6931 380.552 79.6908C379.593 78.713 378.133 78.713 377.174 79.6908L375.484 81.381",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.174 83.9755C376.354 82.8203 374.64 82.9639 373.795 83.9164L372.106 85.5855C371.157 86.6233 371.123 87.9848 372.106 88.9871C373.066 89.9649 374.525 89.9649 375.484 88.9871L377.174 87.2969",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 382.067,
    cy: 179.269,
    rx: 5.96907,
    ry: 5.97276,
    fill: "#47ECFE",
    fillOpacity: 0.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.3858,
    cy: 256.502,
    rx: 3.48196,
    ry: 3.48411,
    fill: "#47ECFE"
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.8917,
    cy: 66.7819,
    rx: 20.8917,
    ry: 20.9047,
    fill: "#46EDC3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0107 67.6636C30.4445 69.6854 33.4612 69.3304 34.9392 67.6636L37.8791 64.7057C39.5404 62.8895 39.5995 60.5439 37.8791 58.7898C36.2 57.0787 33.6459 57.0787 31.9669 58.7898L29.0107 61.7478",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9668 66.2882C30.5331 64.2664 27.5326 64.5178 26.0546 66.1846L23.0985 69.1056C21.4371 70.9218 21.378 73.3044 23.0985 75.0584C24.7775 76.7696 27.3316 76.7696 29.0107 75.0584L31.9668 72.1005",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.237 146.486L314.241 146.373C314.31 145.143 314.358 143.907 314.384 142.664C314.413 141.289 314.416 139.918 314.392 138.554L316.392 138.52C316.416 139.909 316.413 141.305 316.383 142.707C316.357 143.972 316.308 145.232 316.237 146.486ZM315.921 130.171L313.93 130.361C313.668 127.62 313.3 124.91 312.83 122.233L314.8 121.887C315.279 124.615 315.654 127.378 315.921 130.171ZM313.028 113.713L311.092 114.214C310.405 111.555 309.615 108.936 308.728 106.361L310.618 105.71C311.523 108.333 312.328 111.003 313.028 113.713ZM307.582 97.9166L305.749 98.7156C304.653 96.2014 303.461 93.738 302.177 91.3301L303.942 90.3893C305.25 92.8433 306.465 95.354 307.582 97.9166ZM299.722 83.1713L298.036 84.2476C296.562 81.9387 294.999 79.6911 293.352 77.5097L294.949 76.3048C296.626 78.5278 298.219 80.8183 299.722 83.1713ZM289.654 69.8328L288.157 71.1586C286.343 69.1099 284.45 67.1326 282.482 65.2317L283.871 63.7932C285.877 65.7303 287.806 67.7452 289.654 69.8328ZM277.635 58.2233L276.362 59.7659C274.254 58.0263 272.076 56.3676 269.833 54.7947L270.982 53.1573C273.267 54.7602 275.487 56.4506 277.635 58.2233ZM263.953 48.6288L262.937 50.3513C260.587 48.9646 258.177 47.6673 255.713 46.464L256.59 44.6668C259.102 45.8932 261.558 47.2155 263.953 48.6288ZM248.935 41.2973L248.203 43.1582C245.669 42.1607 243.086 41.2592 240.459 40.4584L241.042 38.5453C243.72 39.3616 246.353 40.2805 248.935 41.2973ZM232.952 36.4251L232.522 38.3784C229.868 37.7941 227.176 37.3104 224.449 36.9317L224.724 34.9507C227.503 35.3367 230.247 35.8296 232.952 36.4251ZM216.403 34.1253L216.283 36.1217C214.921 36.0401 213.552 35.9843 212.176 35.9551C210.8 35.9259 209.43 35.9234 208.066 35.9472L208.031 33.9475C209.421 33.9232 210.817 33.9258 212.219 33.9556C213.621 33.9853 215.015 34.0421 216.403 34.1253ZM199.683 34.4187L199.874 36.4096C197.133 36.6721 194.422 37.0409 191.746 37.512L191.4 35.5423C194.127 35.0621 196.89 34.6862 199.683 34.4187ZM183.226 37.3169L183.728 39.253C181.069 39.9416 178.451 40.7325 175.877 41.6215L175.224 39.7311C177.847 38.825 180.516 38.0187 183.226 37.3169ZM167.433 42.7725L168.234 44.6053C165.72 45.7029 163.258 46.8967 160.851 48.1822L159.909 46.4181C162.362 45.1079 164.872 43.8911 167.433 42.7725ZM152.694 50.644C150.343 52.1484 148.054 53.743 145.832 55.4229L147.039 57.0181C149.219 55.3696 151.465 53.8049 153.772 52.3287L152.694 50.644ZM139.365 60.7229L140.692 62.2191C138.646 64.0347 136.67 65.9298 134.771 67.8996L133.331 66.5114C135.266 64.5041 137.279 62.573 139.365 60.7229ZM127.767 72.7527L129.311 74.0243C127.573 76.1338 125.917 78.313 124.346 80.5572L122.707 79.4102C124.308 77.1232 125.996 74.9024 127.767 72.7527ZM118.185 86.4425L119.908 87.4574C118.523 89.8086 117.228 92.2192 116.026 94.6846L114.228 93.8084C115.453 91.2955 116.773 88.8387 118.185 86.4425ZM110.864 101.465L112.725 102.197C111.729 104.731 110.829 107.314 110.03 109.942L108.117 109.36C108.932 106.681 109.849 104.048 110.864 101.465ZM106 117.451L107.953 117.88C107.37 120.534 106.887 123.227 106.509 125.954L104.528 125.68C104.913 122.9 105.405 120.156 106 117.451ZM103.704 134.001C103.621 135.388 103.564 136.783 103.535 138.185C103.505 139.586 103.502 140.982 103.526 142.372L105.526 142.337C105.502 140.973 105.505 139.603 105.534 138.227C105.563 136.851 105.619 135.482 105.701 134.12L103.704 134.001ZM103.997 150.72L105.988 150.53C106.25 153.271 106.618 155.982 107.088 158.658L105.118 159.004C104.639 156.276 104.264 153.514 103.997 150.72ZM106.89 167.178L108.826 166.678C109.513 169.337 110.303 171.956 111.19 174.53L109.3 175.182C108.395 172.558 107.59 169.889 106.89 167.178ZM112.336 182.975L114.17 182.176C115.265 184.69 116.457 187.154 117.741 189.561L115.976 190.502C114.668 188.048 113.453 185.538 112.336 182.975ZM120.196 197.72L121.882 196.644C123.356 198.953 124.919 201.2 126.566 203.382L124.969 204.587C123.292 202.364 121.699 200.073 120.196 197.72ZM130.264 211.059L131.761 209.733C133.575 211.782 135.468 213.759 137.436 215.66L136.047 217.098C134.041 215.161 132.112 213.146 130.264 211.059ZM142.283 222.668L143.556 221.126C145.664 222.865 147.842 224.524 150.085 226.097L148.936 227.734C146.651 226.131 144.431 224.441 142.283 222.668ZM155.965 232.263L156.981 230.54C159.331 231.927 161.741 233.224 164.205 234.427L163.328 236.225C160.816 234.998 158.36 233.676 155.965 232.263ZM170.983 239.594L171.716 237.733C174.249 238.731 176.832 239.632 179.459 240.433L178.876 242.346C176.198 241.53 173.565 240.611 170.983 239.594ZM186.966 244.466L187.396 242.513C190.05 243.097 192.742 243.581 195.469 243.96L195.194 245.941C192.415 245.555 189.671 245.062 186.966 244.466ZM203.515 246.766L203.635 244.77C204.997 244.851 206.366 244.907 207.742 244.936C209.009 244.963 210.272 244.968 211.529 244.949L211.558 246.949C210.277 246.968 208.99 246.963 207.699 246.936C206.297 246.906 204.903 246.849 203.515 246.766ZM219.263 246.561L219.09 244.569C221.621 244.35 224.126 244.04 226.603 243.643L226.919 245.618C224.395 246.023 221.842 246.338 219.263 246.561ZM234.488 244.12L234.028 242.174C236.495 241.591 238.928 240.921 241.325 240.166L241.926 242.074C239.483 242.843 237.002 243.526 234.488 244.12ZM249.195 239.49L248.457 237.631C249.631 237.165 250.795 236.678 251.949 236.17C253.082 235.672 254.205 235.154 255.317 234.616L256.187 236.417C255.054 236.965 253.909 237.493 252.754 238.001C251.579 238.518 250.392 239.015 249.195 239.49ZM262.872 232.887L261.876 231.153C264.024 229.919 266.124 228.611 268.173 227.232L269.29 228.892C267.202 230.297 265.061 231.63 262.872 232.887ZM275.409 224.452L274.178 222.876C276.128 221.352 278.023 219.761 279.859 218.106L281.199 219.591C279.327 221.278 277.396 222.9 275.409 224.452ZM286.631 214.334L285.191 212.947C286.905 211.166 288.558 209.324 290.145 207.425L291.68 208.707C290.063 210.643 288.379 212.519 286.631 214.334ZM296.318 202.738L294.696 201.567C296.142 199.565 297.518 197.509 298.822 195.402L300.522 196.455C299.193 198.602 297.791 200.697 296.318 202.738ZM304.27 189.89L302.499 188.961C303.645 186.777 304.716 184.547 305.708 182.274L307.541 183.075C306.529 185.391 305.438 187.664 304.27 189.89ZM310.317 176.043L308.432 175.376C309.254 173.054 309.996 170.695 310.656 168.3L312.584 168.832C311.912 171.272 311.155 173.677 310.317 176.043ZM314.33 161.476L312.369 161.084C312.851 158.673 313.251 156.232 313.565 153.763L315.549 154.015C315.229 156.531 314.822 159.019 314.33 161.476Z",
    fill: "#1CE8B6"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.2903,
    cy: 160.853,
    rx: 11.5118,
    ry: 11.5189,
    fill: "#46EDC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8055 161.339C49.5955 162.453 51.2578 162.257 52.0723 161.339L53.6922 159.709C54.6076 158.708 54.6402 157.416 53.6922 156.449C52.767 155.506 51.3596 155.506 50.4344 156.449L48.8055 158.079",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4345 160.581C49.6445 159.467 47.9912 159.605 47.1767 160.524L45.5478 162.133C44.6324 163.134 44.5998 164.447 45.5478 165.413C46.473 166.356 47.8804 166.356 48.8056 165.413L50.4345 163.784",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 144.299,
    y: 47.8687,
    width: 16.9124,
    height: 6.96822,
    fill: "#EEFEFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16.9184,
    height: 12.4947,
    transform: "matrix(0.652349 -0.757919 0.75752 0.652812 230.85 41.7773)",
    fill: "#EEFEFA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 309.443,
    y: 150.401,
    width: 13.9278,
    height: 8.95914,
    fill: "#EDFDFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 309.443,
    y: 150.401,
    width: 13.9278,
    height: 8.95914,
    fill: "#EDFDFA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 303.474,
    y: 110.582,
    width: 13.9278,
    height: 8.95914,
    fill: "#EDFDFA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 99.5309,
    y: 159.36,
    width: 13.9278,
    height: 8.95914,
    fill: "#EDFDFA"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 251,
    y: 152,
    width: 75,
    height: 75
  }, /*#__PURE__*/React.createElement("rect", {
    x: 251.742,
    y: 152.392,
    width: 73.6185,
    height: 73.664,
    rx: 14,
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 251.742,
    y: 152.392,
    width: 73.6185,
    height: 73.664,
    rx: 14,
    fill: "#518CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.058 199.555C303.365 196.411 304.743 177.212 301.422 172.382C298.815 168.634 294.531 166.498 289.037 166.498C283.202 166.498 279.228 168.356 276.745 172.753C274.076 177.429 273.289 197.758 270.103 202.25C265.209 210.335 273.289 216.623 273.289 216.623L305.161 216.174C305.161 216.174 312.343 208.089 306.058 199.555Z",
    fill: "#15285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.691 189.693C277.405 189.693 278.795 188.306 278.795 186.596C278.795 184.886 277.405 183.499 275.691 183.499C273.976 183.499 272.587 184.886 272.587 186.596C272.587 188.306 273.976 189.693 275.691 189.693Z",
    fill: "#FFD7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.038 205.672C291.273 205.672 293.415 204.402 295.122 202.173C294.967 199.478 295.215 197.001 295.215 197.001H282.985C282.985 197.001 283.016 199.045 282.83 201.429C282.83 201.615 282.799 201.77 282.799 201.956C284.506 204.309 286.71 205.672 289.038 205.672Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.384 189.693C304.099 189.693 305.488 188.306 305.488 186.596C305.488 184.886 304.099 183.499 302.384 183.499C300.67 183.499 299.28 184.886 299.28 186.596C299.28 188.306 300.67 189.693 302.384 189.693Z",
    fill: "#FFD7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.722 183.499C275.722 183.499 275.66 185.481 275.66 186.503C275.66 187.618 275.753 188.671 275.877 189.693H275.38C274.914 186.132 275.722 183.499 275.722 183.499Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.324 183.499C302.324 183.499 302.386 185.481 302.386 186.503C302.386 187.618 302.292 188.671 302.168 189.693H302.665C303.131 186.132 302.324 183.499 302.324 183.499Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.938 171.257C293.938 171.257 287.647 177.732 284.512 180.24C284.512 180.24 278.609 183.932 275.722 183.561C275.691 184.521 275.691 185.512 275.691 186.503C275.691 196.32 281.93 203.318 289.039 203.318C296.147 203.318 302.386 196.35 302.386 186.503C302.386 185.512 302.386 184.521 302.324 183.53C297.978 182.486 293.938 171.257 293.938 171.257Z",
    fill: "#FFD7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.6 189.291C294.629 189.291 295.463 188.251 295.463 186.968C295.463 185.685 294.629 184.646 293.6 184.646C292.572 184.646 291.738 185.685 291.738 186.968C291.738 188.251 292.572 189.291 293.6 189.291Z",
    fill: "#282B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.991 182.508C295.432 182.044 294.314 181.92 293.6 181.951C291.738 181.982 291.024 182.26 291.024 182.601C290.993 182.942 292.079 183.066 292.855 183.128C293.663 183.189 295.028 183.251 295.711 183.128C296.363 183.035 296.146 182.632 295.991 182.508Z",
    fill: "#44251B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.084 182.508C282.643 182.044 283.76 181.92 284.474 181.951C286.337 181.982 287.051 182.26 287.051 182.601C287.082 182.942 285.995 183.066 285.219 183.128C284.412 183.189 283.047 183.251 282.364 183.128C281.712 183.035 281.929 182.632 282.084 182.508Z",
    fill: "#44251B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.476 189.291C285.504 189.291 286.338 188.251 286.338 186.968C286.338 185.685 285.504 184.646 284.476 184.646C283.447 184.646 282.613 185.685 282.613 186.968C282.613 188.251 283.447 189.291 284.476 189.291Z",
    fill: "#282B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.131 196.258C287.859 196.258 286.586 195.917 285.934 195.205C285.717 194.988 285.717 194.616 285.934 194.369C286.151 194.152 286.524 194.152 286.772 194.369C287.61 195.236 290.528 195.36 291.646 194.338C291.894 194.121 292.266 194.152 292.453 194.369C292.67 194.616 292.639 194.988 292.422 195.174C291.646 195.948 290.373 196.258 289.131 196.258Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.161 192.913C289.13 192.913 289.099 192.913 289.068 192.913L288.416 192.727C287.703 192.541 287.299 191.798 287.485 191.117L288.323 187.803C288.385 187.586 288.602 187.463 288.789 187.524C289.006 187.586 289.13 187.803 289.068 187.989L288.23 191.303C288.168 191.612 288.323 191.891 288.633 191.984L289.285 192.17C289.502 192.232 289.626 192.448 289.564 192.634C289.502 192.789 289.347 192.913 289.161 192.913Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.446 226.389H261.722C261.722 216.666 269.607 208.8 279.353 208.8H298.846C308.562 208.8 316.446 216.697 316.446 226.389Z",
    fill: "#93D4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.258 208.8C296.799 208.8 295.992 207.376 295.557 205.518C295.309 204.496 295.185 203.319 295.123 202.173C293.416 204.403 291.305 205.672 289.039 205.672C286.711 205.672 284.507 204.31 282.8 201.925C282.489 205.177 281.744 208.8 279.944 208.8C285.904 212.361 291.988 212.423 298.258 208.8Z",
    fill: "#FFD7CA"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 163,
    width: 95,
    height: 94
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.6494,
    y: 163.342,
    width: 93.5154,
    height: 93.5732,
    rx: 20,
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.6494,
    y: 163.342,
    width: 93.5154,
    height: 93.5732,
    rx: 20,
    fill: "#64CECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.506 256.599H89.5824C89.5824 244.789 99.2242 235.236 111.144 235.236H134.982C146.864 235.236 156.506 244.789 156.506 256.599Z",
    fill: "#6B778A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.702 212.03C108.799 212.03 110.498 210.346 110.498 208.269C110.498 206.191 108.799 204.507 106.702 204.507C104.606 204.507 102.906 206.191 102.906 208.269C102.906 210.346 104.606 212.03 106.702 212.03Z",
    fill: "#FFD7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.063 231.438C125.796 231.438 128.416 229.896 130.503 227.188C130.314 223.916 130.617 220.907 130.617 220.907H115.623C115.623 220.907 115.661 223.389 115.433 226.285C115.433 226.511 115.395 226.699 115.395 226.925C117.521 229.783 120.216 231.438 123.063 231.438Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.385 212.03C141.482 212.03 143.181 210.346 143.181 208.269C143.181 206.191 141.482 204.507 139.385 204.507C137.289 204.507 135.589 206.191 135.589 208.269C135.589 210.346 137.289 212.03 139.385 212.03Z",
    fill: "#FFD7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.779 204.507C106.779 204.507 106.703 206.915 106.703 208.156C106.703 209.51 106.817 210.789 106.969 212.03H106.361C105.791 207.704 106.779 204.507 106.779 204.507Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.31 204.507C139.31 204.507 139.386 206.915 139.386 208.156C139.386 209.51 139.272 210.789 139.12 212.03H139.727C140.297 207.704 139.31 204.507 139.31 204.507Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.063 185.966C138.02 185.966 139.386 196.196 139.386 208.119C139.386 220.041 131.756 228.541 123.063 228.541C114.371 228.541 106.741 220.079 106.741 208.119C106.741 196.158 108.107 185.966 123.063 185.966Z",
    fill: "#FFD7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.606 211.503C129.864 211.503 130.884 210.24 130.884 208.682C130.884 207.124 129.864 205.861 128.606 205.861C127.348 205.861 126.329 207.124 126.329 208.682C126.329 210.24 127.348 211.503 128.606 211.503Z",
    fill: "#282B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.566 203.304C130.883 202.74 129.516 202.589 128.643 202.627C126.365 202.665 125.492 203.003 125.492 203.417C125.454 203.83 126.783 203.981 127.732 204.056C128.719 204.131 130.389 204.207 131.224 204.056C132.021 203.943 131.756 203.454 131.566 203.304Z",
    fill: "#44331B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.522 203.304C115.206 202.74 116.572 202.589 117.445 202.627C119.723 202.665 120.596 203.003 120.596 203.417C120.634 203.83 119.305 203.981 118.356 204.056C117.369 204.131 115.699 204.207 114.864 204.056C114.067 203.943 114.333 203.454 114.522 203.304Z",
    fill: "#44331B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.482 211.503C118.74 211.503 119.76 210.24 119.76 208.682C119.76 207.124 118.74 205.861 117.482 205.861C116.224 205.861 115.205 207.124 115.205 208.682C115.205 210.24 116.224 211.503 117.482 211.503Z",
    fill: "#282B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.139 220.003C121.582 220.003 120.026 219.589 119.229 218.724C118.963 218.461 118.963 218.009 119.229 217.708C119.495 217.445 119.95 217.445 120.254 217.708C121.279 218.761 124.847 218.912 126.214 217.671C126.517 217.407 126.973 217.445 127.201 217.708C127.466 218.009 127.428 218.461 127.163 218.686C126.252 219.627 124.695 220.003 123.139 220.003Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.216 215.942C123.178 215.942 123.14 215.942 123.102 215.942L122.305 215.716C121.431 215.491 120.938 214.588 121.166 213.76L122.191 209.736C122.267 209.473 122.532 209.322 122.76 209.398C123.026 209.473 123.178 209.736 123.102 209.962L122.077 213.986C122.001 214.362 122.191 214.701 122.57 214.814L123.367 215.039C123.633 215.114 123.785 215.378 123.709 215.603C123.595 215.791 123.405 215.942 123.216 215.942Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.386 204.507C139.386 204.507 137.146 205.147 135.59 202.627C134.793 201.273 135.628 196.572 133.92 195.782C128.985 193.525 122.608 200.182 117.483 200.445C111.182 200.784 111.258 196.271 111.258 196.271C111.258 196.271 111.637 202.777 106.702 204.507C106.702 204.507 105.45 199.129 105.45 194.954C105.45 190.779 107.727 184.235 116.724 182.279C135.59 178.18 135.59 187.771 135.59 187.771C135.59 187.771 138.513 186.153 140.828 190.065C143.182 193.939 139.386 204.507 139.386 204.507Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.338 235.236C132.554 235.236 131.567 233.506 131.035 231.249C130.732 230.008 130.58 228.578 130.504 227.187C128.416 229.895 125.835 231.437 123.064 231.437C120.217 231.437 117.522 229.782 115.434 226.886C115.054 230.835 114.143 235.236 111.941 235.236C119.419 239.222 126.898 239.222 134.338 235.236Z",
    fill: "#FFD7CA"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 235,
    y: 37,
    width: 83,
    height: 83
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.825,
    y: 37.9136,
    width: 81.5773,
    height: 81.6277,
    rx: 17,
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.825,
    y: 37.9136,
    width: 81.5773,
    height: 81.6277,
    rx: 17,
    fill: "#A6CFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.524 119.912H246.884C246.884 109.136 255.62 100.42 266.421 100.42H288.021C298.787 100.42 307.524 109.171 307.524 119.912Z",
    fill: "#A6AFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.447 79.7962C292.836 77.2912 294.556 65.418 290.875 60.0648C287.986 55.9127 283.239 53.5449 277.151 53.5449C270.685 53.5449 266.282 55.6038 263.53 60.4766C260.572 65.6583 262.12 76.3303 257.786 79.7962C251.664 84.7033 256.17 90.6399 256.17 90.6399H298.821C298.821 90.6399 304.221 85.2523 296.447 79.7962Z",
    fill: "#282B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.362 79.2481C264.262 79.2481 265.802 77.7117 265.802 75.8165C265.802 73.9214 264.262 72.385 262.362 72.385C260.463 72.385 258.923 73.9214 258.923 75.8165C258.923 77.7117 260.463 79.2481 262.362 79.2481Z",
    fill: "#FFD7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.152 96.954C279.629 96.954 282.002 95.5471 283.894 93.0764C283.722 90.0909 283.997 87.3457 283.997 87.3457H270.445C270.445 87.3457 270.479 89.6105 270.273 92.2528C270.273 92.4587 270.239 92.6303 270.239 92.8362C272.13 95.4441 274.573 96.954 277.152 96.954Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.942 79.2481C293.841 79.2481 295.381 77.7117 295.381 75.8165C295.381 73.9214 293.841 72.385 291.942 72.385C290.042 72.385 288.502 73.9214 288.502 75.8165C288.502 77.7117 290.042 79.2481 291.942 79.2481Z",
    fill: "#FFD7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.397 72.385C262.397 72.385 262.328 74.5812 262.328 75.7136C262.328 76.949 262.431 78.1157 262.569 79.2481H262.018C261.502 75.3018 262.397 72.385 262.397 72.385Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.874 72.385C291.874 72.385 291.943 74.5812 291.943 75.7136C291.943 76.949 291.84 78.1157 291.702 79.2481H292.253C292.769 75.3018 291.874 72.385 291.874 72.385Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.758 61.5056C269.758 61.5056 269.139 66.1725 265.665 68.9521C265.665 68.9521 265.596 72.864 262.397 72.4522C262.363 73.516 262.363 74.6141 262.363 75.7122C262.363 86.5902 269.276 94.3454 277.153 94.3454C285.03 94.3454 291.943 86.6245 291.943 75.7122C291.943 74.6141 291.943 73.516 291.875 72.4179C278.082 70.9767 269.758 61.5056 269.758 61.5056Z",
    fill: "#FFD7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.208 78.8014C283.347 78.8014 284.271 77.6491 284.271 76.2277C284.271 74.8063 283.347 73.6541 282.208 73.6541C281.068 73.6541 280.144 74.8063 280.144 76.2277C280.144 77.6491 281.068 78.8014 282.208 78.8014Z",
    fill: "#282B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.856 71.2857C284.237 70.771 282.999 70.6337 282.208 70.668C280.144 70.7024 279.353 71.0112 279.353 71.3887C279.319 71.7661 280.522 71.9034 281.382 71.972C282.277 72.0407 283.79 72.1093 284.547 71.972C285.269 71.8691 285.028 71.423 284.856 71.2857Z",
    fill: "#44331B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.447 71.2857C270.066 70.771 271.304 70.6337 272.095 70.668C274.159 70.7024 274.95 71.0112 274.95 71.3887C274.985 71.7661 273.781 71.9034 272.921 71.972C272.027 72.0407 270.513 72.1093 269.756 71.972C269.034 71.8691 269.275 71.423 269.447 71.2857Z",
    fill: "#44331B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.096 78.8014C273.236 78.8014 274.16 77.6491 274.16 76.2277C274.16 74.8063 273.236 73.6541 272.096 73.6541C270.957 73.6541 270.033 74.8063 270.033 76.2277C270.033 77.6491 270.957 78.8014 272.096 78.8014Z",
    fill: "#282B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.256 86.5222C275.845 86.5222 274.435 86.1447 273.713 85.3555C273.472 85.1152 273.472 84.7035 273.713 84.4289C273.954 84.1887 274.366 84.1887 274.641 84.4289C275.57 85.3898 278.803 85.527 280.042 84.3946C280.317 84.1544 280.73 84.1887 280.936 84.4289C281.177 84.7035 281.142 85.1152 280.902 85.3211C280.042 86.179 278.631 86.5222 277.256 86.5222Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.29 82.8159C277.255 82.8159 277.221 82.8159 277.186 82.8159L276.464 82.61C275.673 82.4042 275.226 81.5806 275.432 80.8256L276.361 77.1539C276.43 76.9137 276.67 76.7764 276.877 76.8451C277.118 76.9137 277.255 77.1539 277.186 77.3598L276.258 81.0315C276.189 81.3747 276.361 81.6835 276.705 81.7865L277.427 81.9924C277.668 82.061 277.805 82.3012 277.737 82.5071C277.668 82.6787 277.496 82.8159 277.29 82.8159Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.369 100.42C285.752 100.42 284.858 98.8415 284.376 96.7826C284.101 95.6502 283.963 94.3462 283.895 93.0765C282.003 95.5472 279.664 96.9542 277.153 96.9542C274.573 96.9542 272.131 95.4443 270.239 92.802C269.895 96.4051 269.07 100.42 267.075 100.42C273.679 104.366 280.421 104.435 287.369 100.42Z",
    fill: "#FFD7CA"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 52,
    width: 81,
    height: 81
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.5669,
    y: 52.8457,
    width: 79.5876,
    height: 79.6368,
    rx: 15,
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.5669,
    y: 52.8457,
    width: 79.5876,
    height: 79.6368,
    rx: 15,
    fill: "#43A1BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.53 133.061H103.574C103.574 123.01 111.78 114.879 121.924 114.879H142.212C152.324 114.879 160.53 123.01 160.53 133.061Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.144 95.1292C119.928 95.1292 121.375 93.6961 121.375 91.9282C121.375 90.1604 119.928 88.7273 118.144 88.7273C116.36 88.7273 114.913 90.1604 114.913 91.9282C114.913 93.6961 116.36 95.1292 118.144 95.1292Z",
    fill: "#FFD7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.067 111.647C134.394 111.647 136.623 110.334 138.4 108.03C138.238 105.245 138.496 102.684 138.496 102.684H125.735C125.735 102.684 125.768 104.797 125.574 107.261C125.574 107.453 125.542 107.614 125.542 107.806C127.351 110.238 129.645 111.647 132.067 111.647Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.96 95.1292C147.744 95.1292 149.191 93.6961 149.191 91.9282C149.191 90.1604 147.744 88.7273 145.96 88.7273C144.176 88.7273 142.729 90.1604 142.729 91.9282C142.729 93.6961 144.176 95.1292 145.96 95.1292Z",
    fill: "#FFD7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.209 88.7273C118.209 88.7273 118.144 90.7759 118.144 91.8322C118.144 92.9846 118.241 94.0729 118.371 95.1292H117.853C117.369 91.4481 118.209 88.7273 118.209 88.7273Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.895 88.7273C145.895 88.7273 145.959 90.7759 145.959 91.8322C145.959 92.9846 145.862 94.0729 145.733 95.1292H146.25C146.735 91.4481 145.895 88.7273 145.895 88.7273Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.068 72C144 72 145.96 81.6538 145.96 91.8009C145.96 101.948 139.466 109.182 132.068 109.182C124.67 109.182 118.177 101.98 118.177 91.8009C118.177 81.6218 121 72 132.068 72Z",
    fill: "#FFD7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.786 94.6811C137.856 94.6811 138.724 93.6062 138.724 92.2803C138.724 90.9545 137.856 89.8796 136.786 89.8796C135.715 89.8796 134.848 90.9545 134.848 92.2803C134.848 93.6062 135.715 94.6811 136.786 94.6811Z",
    fill: "#282B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.318 94.6811C128.388 94.6811 129.256 93.6062 129.256 92.2803C129.256 90.9545 128.388 89.8796 127.318 89.8796C126.247 89.8796 125.38 90.9545 125.38 92.2803C125.38 93.6062 126.247 94.6811 127.318 94.6811Z",
    fill: "#282B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.132 101.915C130.808 101.915 129.483 101.563 128.805 100.827C128.579 100.602 128.579 100.218 128.805 99.9623C129.031 99.7382 129.419 99.7382 129.677 99.9623C130.549 100.859 133.586 100.987 134.749 99.9302C135.008 99.7062 135.395 99.7382 135.589 99.9623C135.815 100.218 135.783 100.602 135.557 100.795C134.782 101.595 133.457 101.915 132.132 101.915Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.197 98.4589C132.165 98.4589 132.132 98.4589 132.1 98.4589L131.421 98.2669C130.678 98.0748 130.258 97.3066 130.452 96.6024L131.325 93.1774C131.389 92.9533 131.615 92.8253 131.809 92.8893C132.035 92.9533 132.165 93.1774 132.1 93.3694L131.228 96.7944C131.163 97.1145 131.325 97.4026 131.648 97.4987L132.326 97.6907C132.552 97.7547 132.681 97.9788 132.617 98.1709C132.52 98.3309 132.358 98.4589 132.197 98.4589Z",
    fill: "#DBB3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.663 114.88C140.145 114.88 139.305 113.407 138.853 111.487C138.594 110.43 138.465 109.214 138.401 108.03C136.624 110.334 134.427 111.647 132.069 111.647C129.646 111.647 127.352 110.238 125.575 107.774C125.252 111.135 124.477 114.88 122.603 114.88C128.967 118.273 135.331 118.273 141.663 114.88Z",
    fill: "#FFD7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.3 72.7441C133.295 72.7441 134.102 71.8083 134.102 70.6539C134.102 69.4995 133.295 68.5637 132.3 68.5637C131.305 68.5637 130.499 69.4995 130.499 70.6539C130.499 71.8083 131.305 72.7441 132.3 72.7441Z",
    fill: "#164F78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.573 85.5854C119.496 84.4644 133.248 77.0547 147.044 85.5854C147.111 85.6279 147.169 85.6862 147.215 85.7566C147.261 85.827 147.294 85.9079 147.312 85.9941L148.057 89.7116C148.078 89.8152 148.075 89.9234 148.049 90.0255C148.023 90.1275 147.974 90.2198 147.907 90.2931C147.841 90.3663 147.759 90.418 147.67 90.4429C147.58 90.4678 147.487 90.465 147.399 90.4348C144.204 89.2053 132.166 85.4661 117.308 90.5289C117.22 90.5562 117.129 90.5567 117.041 90.5305C116.954 90.5042 116.874 90.4521 116.809 90.3792C116.744 90.3062 116.697 90.215 116.672 90.1144C116.647 90.0139 116.645 89.9075 116.665 89.8056L117.289 85.9941C117.306 85.9054 117.341 85.8225 117.39 85.7516C117.439 85.6808 117.502 85.624 117.573 85.5854Z",
    fill: "#164F78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.3 82.8298C137.258 82.785 142.188 83.6804 146.897 85.4805C146.425 81.3775 144.685 77.6128 142 74.8863C139.316 72.1597 135.869 70.6567 132.301 70.6567C128.734 70.6567 125.287 72.1597 122.603 74.8863C119.918 77.6128 118.178 81.3775 117.706 85.4805C122.414 83.6803 127.343 82.7849 132.3 82.8298Z",
    fill: "#2879B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 140.745,
    y: 102.596,
    width: 132.538,
    height: 237.96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 362.048,
    y: 70.3123,
    width: 27.8763,
    height: 27.891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    x: 374.098,
    y: 171.296,
    width: 15.9381,
    height: 15.9455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 41.9038,
    y: 251.018,
    width: 10.9639,
    height: 10.9682,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f",
    x: 35.7786,
    y: 147.334,
    width: 27.0236,
    height: 27.0378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPeopleLink);
export default __webpack_public_path__ + "static/media/img_people_link.63ced795.svg";
export { ForwardRef as ReactComponent };